"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRAPH_URLS = exports.OrderDirection = void 0;
var OrderDirection;
(function (OrderDirection) {
    OrderDirection[OrderDirection["ASC"] = 0] = "ASC";
    OrderDirection[OrderDirection["DESC"] = 1] = "DESC";
})(OrderDirection = exports.OrderDirection || (exports.OrderDirection = {}));
exports.GRAPH_URLS = {
    1: "https://api.studio.thegraph.com/query/78581/union-v1-mainnet/version/latest",
    10: "https://api.studio.thegraph.com/query/78581/union-finance/version/latest",
    8453: "https://api.studio.thegraph.com/query/78581/union-v2-base/version/latest",
    42161: "https://api.studio.thegraph.com/query/78581/union-v1-arbitrum/version/latest",
};
